export function formatCoins(value, options = {}) {
  const amount = Number(value)
  const safeAmount = Number.isFinite(amount) ? amount : 0

  return new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
    ...options,
  }).format(safeAmount)
}

export function formatCoinsLabel(value, options = {}) {
  return `${formatCoins(value, options)} Coins`
}
